import React from 'react';
import '../styles/components/Toast.css';

// Renders the ToastProvider's current single message, or nothing. A plain
// status region (not a dialog) — it never grabs focus; it disappears on its
// own once ToastProvider's auto-dismiss timer clears the message.
export default function Toast({ message }) {
  if (!message) return null;

  return (
    <div className="toast" role="status">
      {message}
    </div>
  );
}
